import { SearchType } from '../types/searchType';
import { MostPopularType } from '../types/mostPopularType';
import { SingleVideoType } from '../types/singleVideoType';
import { fetchRequestType, SearchBarState, HomepageState, ModalState } from '../types/types';
import { MOSTPOPULARLINK, SEARCHLINK, SINGLEVIDEO } from '../utils/constants';

const generateLSKey = (key: string) => `react-outlaw-${key}`;

const fetchRequest = async (url: string) => {
  const responseObj: fetchRequestType = {
    response: null,
    error: false,
  };
  try {
    const req = await fetch(url);
    if (!req.ok) {
      const message = `An error has occured: ${req.status}`;
      throw new Error(message);
    }
    responseObj.response = await req.json();
    return responseObj;
  } catch (err) {
    console.error(err);
    responseObj.error = true;
    return responseObj;
  }
};

const setLSData = (key: string, value: string) => {
  const stringified = JSON.stringify(value);
  window.localStorage.setItem(generateLSKey(key), stringified);
};

const getLSData = (key: string): string => {
  const stored = window.localStorage.getItem(generateLSKey(key));
  return stored ? JSON.parse(stored) : '';
};

const getJSONData = async () => {
  const responseObj = (await fetchRequest('data/cards.json')) as fetchRequestType;
  return responseObj;
};

const getApiLink = (
  search: string,
  isSingleCard?: boolean,
  options?: SearchBarState,
  pageToken?: string | null
) => {
  let link = '';

  if (isSingleCard) {
    link = SINGLEVIDEO + search;
  } else if (search !== '') {
    const { maxResults, regionCode, videoOrder, videoType } = options as SearchBarState;
    link = `${SEARCHLINK}&maxResults=${maxResults}&regionCode=${regionCode}&order=${videoOrder}&type=${videoType}&q=${search}${
      pageToken ? '&pageToken=' + pageToken : ''
    }`;
  } else {
    const { maxResults, regionCode } = options as SearchBarState;
    link = `${MOSTPOPULARLINK}&maxResults=${maxResults}&regionCode=${regionCode}${
      pageToken ? '&pageToken=' + pageToken : ''
    }`;
  }

  return link;
};

const getApiData = async (
  search: string,
  isSingleCard?: boolean,
  options?: SearchBarState,
  pageToken?: string | null
): Promise<HomepageState | ModalState> => {
  const link = getApiLink(search, isSingleCard, options, pageToken);
  const responseObj = await fetchRequest(link);

  if (isSingleCard) {
    const responseCopy = responseObj.response as SingleVideoType | null;
    const responseDataCopy = {
      isModalLoaded: true,
      modalCard: responseCopy ? responseCopy.items[0] : null,
      hasModalError: responseObj.error,
    };
    return responseDataCopy;
  } else if (search !== '') {
    if (responseObj.response) {
      const responseCopy = responseObj.response;
      (responseCopy as SearchType).items.map((item, i) => {
        responseObj.response!.items[i].id = item.id.videoId;
      });
    }
  }
  const responseCopy = responseObj.response as SearchType | MostPopularType | null;
  const prevPage = responseCopy
    ? responseCopy.prevPageToken
      ? responseCopy.prevPageToken
      : null
    : null;
  const responseDataCopy = {
    cards: responseCopy ? responseCopy.items : null,
    isLoaded: true,
    hasError: responseObj.error,
    prevPageToken: prevPage,
    nextPageToken: responseCopy ? responseCopy.nextPageToken : null,
    totalResults: responseCopy ? responseCopy.pageInfo.totalResults : null,
    resultsPerPage: responseCopy ? responseCopy.pageInfo.resultsPerPage : null,
  };
  return responseDataCopy;
};

export { setLSData, getLSData, getJSONData, generateLSKey, getApiData };
